import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
//
//
//
//
//
//

export default {
  props: ['list', 'maxLines', 'type'],
  mounted: function mounted() {
    this.init();
  },
  watch: {
    list: {
      handler: function handler(val) {
        this.init();
      }
    }
  },
  methods: {
    init: function init() {
      var artistContainer = this.$refs.artistContainer;
      var artistDiv = this.$refs.artist;
      artistDiv.innerHTML = ''; // 清空艺人div的文本内容

      var maxLines = this.maxLines || 1; // 最多允许行数，默认1行
      var containerWidth = artistContainer.offsetWidth - 1;

      // 创建临时span元素用于测量文本宽度
      var tempSpan = document.createElement('span');
      tempSpan.style.whiteSpace = 'nowrap';
      tempSpan.style.visibility = 'hidden';
      artistDiv.appendChild(tempSpan);
      var currentLineText = ''; // 当前行的文本
      var lineCount = 1; // 当前行数
      var totalText = ''; // 存储最终内容
      var _iterator = _createForOfIteratorHelper(this.list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var obj = _step.value;
          var nameParts = '';
          if (this.type === 'new') {
            var str = obj.replace(/\s/g, "");
            nameParts += str;
          } else {
            if (!obj.highlightVOS) continue;
            var _iterator2 = _createForOfIteratorHelper(obj.highlightVOS),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var val = _step2.value;
                var _str = val.celebrityPartName.replace(/\s/g, "");
                nameParts += val.isHighlight ? "<span style=\"color: #F03D37; font-weight: 600\">".concat(_str, "</span>") : _str;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
          var nameWithSpace = nameParts + ' ';
          tempSpan.innerHTML = currentLineText + nameWithSpace;

          // console.log('容器宽度', containerWidth)
          // console.log('总宽度', tempSpan.offsetWidth)
          if (tempSpan.offsetWidth > containerWidth) {
            if (lineCount < maxLines) {
              totalText += currentLineText + ' ';
              currentLineText = nameWithSpace; // 开始新的一行
              lineCount++;
            } else {
              // 达到最大行数时处理溢出逻辑
              var truncatedText = currentLineText;
              tempSpan.innerHTML = truncatedText + nameWithSpace;
              while (tempSpan.offsetWidth > containerWidth && truncatedText.length > 0) {
                truncatedText = truncatedText.substring(0, truncatedText.lastIndexOf(' ')).trim();
                tempSpan.innerHTML = truncatedText + ' ...';
              }
              totalText += truncatedText + ' ...';
              artistDiv.innerHTML = totalText;
              tempSpan.remove();
              return;
            }
          } else {
            currentLineText += nameWithSpace;
          }
        }

        // 将剩余的当前行文本加入总文本中
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      totalText += currentLineText.trim();
      artistDiv.innerHTML = totalText;

      // 移除临时span元素
      tempSpan.remove();
    }
  }
};